import type { Home } from '@lmc/ts-common'
import { useSelector } from 'react-redux'

const useFeatures = (): Home['features'] => {
  const features = useSelector(
    (state: { global: { home: Home } }) => state?.global?.home?.features
  )
  return features
}

export default useFeatures
